import * as React from "react";
import "./CustomerAddressDlg.scss";
import Dialog from "./input/Dialog";
import LabelCtl from "./input/LabelCtl";
import CustomerAddressCtl from "./CustomerAddressCtl";
import { CustomerAddress } from "@testout/testout-commerce/models/commerce/CustomerAddress";

interface CustomerAddressProps {
    hsCompanyId?: number;
    customerNumber?: string;
    defaultAddress?: CustomerAddress;
    isOpen: boolean;
    onClose: (value?: string) => void;
}

interface CustomerAddressState {
    disabled: boolean;
    address?: CustomerAddress;
    error?: string;
}

export default class CustomerAddressDlg extends React.PureComponent<CustomerAddressProps, CustomerAddressState> {
    constructor(props: CustomerAddressProps) {
        super(props);
        this.state = {
            disabled: false,
            address: this.props.defaultAddress !== undefined
                ? new CustomerAddress(this.props.defaultAddress)
                : new CustomerAddress({
                    addressCode: "PRIMARY",
                    postal: { countryCode: "USA" }
                })
        };
    }

    componentDidUpdate(props: CustomerAddressProps) {
        if (!props.isOpen && this.props.isOpen) {
            let address = this.props.defaultAddress !== undefined
                ? new CustomerAddress(this.props.defaultAddress)
                : new CustomerAddress({
                    addressCode: "PRIMARY",
                    postal: { countryCode: "USA" }
                });
            this.setState({ address: address });
        }
    }

    onCustomerAddressChange = (address: CustomerAddress) => {
        this.setState({ address: address });
    }

    //onCreateClick = () => {
    //    this.setState({ disabled: true }, async () => {

    //        try {
    //            const result = await Api.post<Campus>("/api/campuses",
    //                {
    //                    campusName: this.state.campusName ?? "",
    //                    address: this.state.campusPostal?.line1,
    //                    city: this.state.campusPostal?.city,
    //                    region: this.state.campusPostal?.stateOrProvince,
    //                    postalCode: this.state.campusPostal?.postalCode,
    //                    country: this.state.campusPostal?.countryCode,
    //                    campusDisplayStyle: "SCHOOL",
    //                });
    //            this.props.onClose(result.campusId);
    //        } catch (error: any) {
    //            this.setState({ disabled: false, error: error.message });
    //        }
    //    });
    //}

    onClose = () => {
        this.props.onClose(undefined);
    }

    render() {
        return <Dialog title="Manage Other Addresses" className="CustomerAddressDlg" isOpen={this.props.isOpen} disableClose={this.state.disabled} onClose={this.onClose}>
            <LabelCtl label="Address" useDiv={true}>
                <CustomerAddressCtl disabled={this.state.disabled} hsCompanyId={this.props.hsCompanyId} customerNumber= {this.props.customerNumber}
                    address={this.state.address ?? new CustomerAddress({ addressCode: "PRIMARY", postal: { countryCode: "USA" } })}
                    onChange={this.onCustomerAddressChange} />
            </LabelCtl>
            {this.state.error && <div>{this.state.error}</div>}
            <footer>
                <button className="secondary" disabled={this.state.disabled} onClick={this.onClose}>Close</button>
            </footer>
        </Dialog>;
    }
}